export const PRODUCTION_FORMAT_SOURCE = 'production-format'
